import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DialogService } from '@progress/kendo-angular-dialog';

@Directive({
	selector: '[spaqPopupConfirm]'
})
export class PopupConfirmDirective {
	@Input() message = 'Êtes-vous sûr de vouloir continuer ?';
	@Output() confirmAction = new EventEmitter();
	@Input() title = 'Confirmation';

	constructor(private dialogService: DialogService) {}

	@HostListener('click') onClick() {
		this.dialogService
			.open({
				title: this.title,
				content: this.message,
				actions: [{ text: 'Annuler' }, { text: 'Oui', primary: true }]
			})
			.result.subscribe(result => {
				if (result['text'] === 'Oui') {
					this.confirmAction.emit();
				}
			});
	}
}
